import IconButton from "components/Button/IconButton";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useEffect, useRef, useState } from "react";
import { Table } from "react-bootstrap";
import Pagination from "react-js-pagination";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { RemoveRedEye } from "@mui/icons-material";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { Button } from "components/Button/Button";
import { Input } from "components/Form";
import ModalBox from "components/modal/ModalBox";
import parse from "html-react-parser";
import TextEditor from "components/TextEditor/TextEditor";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import "./Post.css"
import { Badge, Fab } from "@mui/material";
import TvIcon from '@mui/icons-material/Tv';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import PlayCircleOutlinedIcon from "@mui/icons-material/PlayCircleOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import Tooltip from "components/Tooltip/Tooltip";
import Select from "react-select";



import {
  objectTypeChecker,
  rawToHtmlConverter,
  wrapImagesWithFigure,
} from "utils";
import Switch from "components/Switch/Switch";
import {
  addGSChapter,
  editGSChapter,
  getGSChapterById,
  getGSChaptersList,
  updateChapterDisplayorder,
  updateStatusGSChapter,
} from "services/gsfreeresources";
import { ContentState, convertFromHTML, EditorState } from "draft-js";
import htmlToDraft from "html-to-draftjs";
import Link from "components/Button/Link";
import { deletePost, getPostbyId, getPostList, updateAudioVisibleStatus, updateDisplayWebsiteStatus, updatePostDisplayorder, updatePostStatus, updateTopDisplay } from "services/blogs/blogs";
import { Badge as BSBadge } from "react-bootstrap";
import { Avatar } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import { useNavigate } from "react-router-dom";
import IframePreview from "components/ImageLoader/IframePreview";
import ReactionsTooltip from "components/ImageLoader/Reactions";
import DisplaySwitch from "components/Switch/DisplaySwitch";



export default function GSPostList() {
  const { sid, cid, cname, sname } = useParams();
  const [record, setRecord] = useState([{}]);
  const [limit, setLimit] = useState(10);
  const [activePage, setActivePage] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [displaywebsiteModal, setdisplaywebsiteModal] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedAudioFlag, setselectedAudioFlag] = useState("");
  const [selectedAudioFlagModal, setselectedAudioFlagModal] = useState(false);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const statusOptions = [
    { value: "", label: "All Status" },
    { value: "Draft", label: "Draft" },
    { value: "Approval Pending", label: "Approval Pending" },
    { value: "Approved", label: "Approved" },
  ];

  const resetFilter = () => {
    setSearch("");
    setSelectedStatus("")
  };


  const [data, setData] = useState({
    // question: EditorState.createEmpty(),
    // explaination: EditorState.createEmpty(),
  });
  const [errorField, setErrorField] = useState({});

  const [viewModal, setViewModal] = useState(false);
  const [shortdescriptionModal, setshortdescriptionModal] = useState(false);
  const [Shortdescription, setshortdescription] = useState(false);
  const [statusModal, setStatusModal] = useState(false);
  const [categoryModal, setcategoryModal] = useState(false);
  const [approveModal, setapproveModal] = useState(false);
  const [categories, setcategories] = useState([]);
  const [editModal, setEditModal] = useState(false);
  const [selectedId, setSelectId] = useState("");
  const usertypeid = localStorage.getItem("roleid")
  console.log("usertypeid", usertypeid);


  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
  const [currentPath, setCurrentPath] = useState([
    { name: `${sname}`, path: "/free-resource/notes" },
    { name: `${cname}`, path: `/free-resource/notes/${sid}/${sname}/subjects` },
    { name: "Chapters", path: `` },
  ]);
  const [newPath, setNewPath] = useState(currentPath);
  const [editedDisplayOrder, setEditedDisplayOrder] = useState({});
  const inputRef = useRef(null);
  const [shouldFocusInput, setShouldFocusInput] = useState(true);
  const [selectedViewUrl, setSelectedViewUrl] = useState("");


  // ***************************************** Fetch Records ********************************************************
  const fetchRecords = async () => {
    showLoader();
    try {
      const res = await getPostList({
        page: activePage,
        search: search,
        limit: limit,
        status: selectedStatus,
      });
      hideLoader();
      if (res.code === 200) {
        const { count, rows } = res.data.Posts;
        setRecord(rows || []);
        setTotal(count || 0);
      } else {
        setRecord([]);
        setTotal(0);
        // toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };
  useEffect(() => {
    fetchRecords();
  }, [search, activePage, limit, selectedStatus]);

  useEffect(() => {
    setActivePage(1);
  }, [search, selectedStatus]);



  // ***************************************** Fetch Data ********************************************************
  const fetchData = async () => {
    showLoader();
    try {
      const res = await getPostbyId({ id: selectedId });
      hideLoader();
      if (res.code === 200) {
        const postContent =
          res.data.description ||
          '<p style="font-weight: 600; font-size: 18px; text-align: center; color: red;">No Content Available</p>';

        setData({
          ...data,
          chaptercontent: postContent, // ✅ Update `chaptercontent` in `data`
          content1: postContent, // Raw HTML content
          content: postContent
            ? EditorState.createWithContent(
              ContentState.createFromBlockArray(
                convertFromHTML(wrapImagesWithFigure(postContent))
              )
            )
            : EditorState.createWithContent(
              ContentState.createFromText("No Content Available")
            ),
        });
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
  };

  // Helper function to group categories by parentcategoryid
  const groupedCategories = categories.reduce((acc, cat) => {
    if (!acc[cat.parentcategoryid]) {
      acc[cat.parentcategoryid] = {
        parentTitle: cat.parentcategorytitle,
        items: [],
      };
    }
    acc[cat.parentcategoryid].items.push(cat);
    return acc;
  }, {});


  useEffect(() => {
    if (data.chaptercontent) {
      const blocksFromHTML = htmlToDraft(data.chaptercontent);
      if (blocksFromHTML) {
        const { contentBlocks, entityMap } = blocksFromHTML;
        const contentState = ContentState.createFromBlockArray(
          contentBlocks,
          entityMap
        );
        setData({
          ...data,
          content: EditorState.createWithContent(contentState),
        });
      }
    }
  }, [data.chaptercontent]);

  // Fetch data when `selectedId` changes
  useEffect(() => {
    if (selectedId) {
      fetchData();
    }
  }, [selectedId]);

  // ***************************************** Form validation ********************************************************
  const handleValidation = () => {
    let isError = false;
    const newErrorField = {};

    const question = objectTypeChecker(data[`content`])
      ? rawToHtmlConverter(data[`content`].getCurrentContent()).length
      : 8;
    if (question == 8) {
      newErrorField.content = "Please Enter Content";
      isError = true;
    } else {
      newErrorField.content = "";
    }

    if (!data.chapter) {
      newErrorField.chapter = "Please Enter Chapter Name";
      isError = true;
    } else {
      newErrorField.chapter = "";
    }

    setErrorField(newErrorField);
    return !isError;
  };


  // ***************************************** Update Status Of Chapter ********************************************************
  const handleStatus = async () => {
    try {
      const res = await updateStatusGSChapter({
        id: selectedId,
      });
      if (res.code == 200) {
        setData({});
        setSelectId("");
        setStatusModal(false);
        fetchRecords();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error("Failed to Update Status Of Subject");
    }
  };

  const handleApprovePost = async () => {
    try {
      const res = await updatePostStatus({
        id: selectedId,
      });
      if (res.code == 200) {
        setData({});
        setSelectId("");
        setapproveModal(false);
        fetchRecords();
        toast.success(res.message);
      } else {
        toast.error(res.message);
      }
    } catch (e) {
      toast.error("Failed to Update Status Of Subject");
    }
  };

  const handleUpdateTopDisplay = async (postid) => {
    setSubmitLoading(true)
    try {
      const res = await updateTopDisplay({
        id: postid,
      });
      if (res.code == 200) {
        setData({});
        setSelectId("");
        fetchRecords();
        toast.success(res.message);
        setSubmitLoading(false)
      } else {
        toast.error(res.message);
        setSubmitLoading(false)
      }
    } catch (e) {
      toast.error("Failed to Update Status");
      setSubmitLoading(false)
    }
  };
  const [hover, setHover] = useState(false);
  const [pos, setPos] = useState({ x: 0, y: 0 });

  const avatarRef = useRef(null);

  const handleMouseEnter = () => {
    if (avatarRef.current) {
      const rect = avatarRef.current.getBoundingClientRect();
      setPos({ x: rect.left + rect.width / 2, y: rect.top });
    }
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  // --------------- getting all required masters data ----------------//
  const [displayOrder, setDisplayOrder] = useState("");

  const handleBlur = async (id, value) => {
    if (value !== "" && id) {
      try {
        const original = displayOrder; // assuming this is coming from props/data

        if (value != original) {
          const res = await updatePostDisplayorder({
            id: id,
            DisplayOrder: value,
          });

          if (res.code === 200) {
            setEditedDisplayOrder((prev) => ({
              ...prev,
              [id]: undefined,
            }));
            fetchRecords();
            toast.success(res.message);
          } else {
            toast.error(res.message);
          }
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
      } finally {
        setSubmitLoading(false);
      }
    }
  };

  const updateDisplayWebsiteHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await updateDisplayWebsiteStatus({
          postid: selectedId,
          websitedisplay: selectedStatus ? 0 : 1,
        });
        if (res.code === 200) {
          fetchRecords();
          toast.success(res.message);
          setdisplaywebsiteModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };
  const updateAudioVisibleHandler = async () => {
    if (selectedId) {
      try {
        setSubmitLoading(true);
        const res = await updateAudioVisibleStatus({
          id: selectedId,
          audioflag: selectedAudioFlag ? 0 : 1,
        });
        if (res.code === 200) {
          fetchRecords();
          toast.success(res.message);
          setselectedAudioFlagModal(false);
          setSubmitLoading(false);
        } else {
          toast.error(res.message);
          setSubmitLoading(false);
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err.message);
        setSubmitLoading(false);
      }
    }
  };

  const handleDeletePost = async () => {
    showLoader();
    try {
      const res = await deletePost({
        postid: selectedId,
      });
      if (res.code === 200) {
        toast.success(res.message);
        setDeleteModal(false);
        fetchRecords();
      } else {
        toast.error(res.message);
        setDeleteModal(false);
        fetchRecords();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    }
    hideLoader();
  };


  // useEffect(() => {
  //   if (inputRef.current && shouldFocusInput) {
  //     inputRef.current.focus();
  //     setShouldFocusInput(false); // Disable automatic focus after the first render
  //   }
  // }, [shouldFocusInput]);

  return (
    <>
      <div className="">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="search_wrap">
              <div className="search_wrap">
                <div className="SearchBox mt-1" style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <Input
                    className="form-control"
                    placeholder="Search Here"
                    value={search}
                    onChange={({ target }) => setSearch(target.value)}
                    type="text"
                    style={{ width: "300px" }}
                  />

                  {/* ✅ React Select for Status */}
                  <div style={{ width: "300px" }}>
                    <Select
                      options={statusOptions}
                      value={statusOptions.find((opt) => opt.value === selectedStatus)}
                      onChange={(option) => setSelectedStatus(option?.value || "")}
                      isClearable
                      placeholder="Select Status"
                      styles={{
                        control: (base) => ({
                          ...base,
                          borderColor: "#ced4da",
                          minHeight: "38px",
                          boxShadow: "none",
                        }),
                      }}
                    />
                  </div>
                  <div>
                    <Button className="refresh_btnn mx-2" onClick={resetFilter}>
                      <i className="fa fa-refresh"></i>
                    </Button>
                  </div>

                  <div>
                    <Button to="add-post" type="acl" role={450006}>
                      Create Post
                    </Button>
                  </div>
                </div>


              </div>
              <h4 className="Title">
                {/* <Link to={-1}>
                  <i className="fa fa-arrow-left"></i>
                </Link> */}
                Posts
              </h4>
            </div>



            {loader}
            <div className="TableList overflow-auto table-responsive">
              {loader}
              <Table bordered className="table">
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Post</th>
                    <th>Title</th>
                    <th className="text-center">Preview</th>
                    <th className="text-center">Categories</th>
                    <th className="text-center">Featured</th>
                    <th className="text-center">Comment</th>
                    <th className="text-center">Top Display</th>
                    <th className="text-center">Audio</th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    <th className="text-center">Display</th>
                    <th className="text-center">Reactions</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record && record.length > 0 ? (
                    record.map(
                      (
                        {
                          id,
                          title,
                          shortdescription,
                          poster,
                          description,
                          sectionid,
                          status,
                          isfeatured,
                          comments,
                          addedon,
                          subjectname,
                          displayorder,
                          websitedisplay,
                          likes,
                          dislikes,
                          views,
                          sectionname,
                          categories,
                          postcommentcount,
                          postdislikes,
                          postlikes,
                          postviews,
                          audioflag
                        },
                        i
                      ) => (
                        <tr key={i}>
                          <td style={{ width: "20px" }}>
                            {++i + (activePage - 1) * limit}
                          </td>
                          <td>
                            <div
                              ref={avatarRef}
                              onMouseEnter={handleMouseEnter}
                              onMouseLeave={handleMouseLeave}
                              style={{ display: 'inline-block', cursor: 'default' }}
                            >
                              <Avatar src={poster} sx={{ width: 36, height: 36 }} alt={poster} />
                            </div>


                          </td>


                          <td style={{ width: "270px", whiteSpace: "normal", wordBreak: "break-word" }}>
                            <Tooltip title={title}>
                              <div
                                style={{
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                }}
                              >
                                {title}
                              </div>
                            </Tooltip>
                          </td>


                          {/* <td>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                onClick={() => {
                                  setshortdescription(shortdescription);
                                  setshortdescriptionModal(true);
                                }}
                              >
                                <RemoveRedEye sx={{ color: "#4971B2" }} />
                              </IconButton>
                            </div></td> */}

                          <td style={{ width: "80px" }}>
                            <div className="d-flex justify-content-center">
                              <IconButton
                                aria-label="view"
                                className="px-1 py-0"
                                // onClick={() => {
                                //   setSelectedViewUrl(`https://www.shubhraranjan.com/blog-post-detail/${id}`);
                                // }}
                                onClick={() => {
                                  setSelectedViewUrl(`https://www.shubhraranjan.com/blog-post-preview/${id}`);
                                }}
                              >
                                <PlayCircleOutlinedIcon
                                  sx={{ fontSize: 28, color: "rgb(115 31 31)" }}

                                />
                              </IconButton>
                            </div>
                          </td>



                          <td style={{ textAlign: "center" }}>
                            {categories && categories.length > 0 ? (
                              <Button
                                style={{ padding: "2px", fontSize: "13px" }}
                                onClick={() => {
                                  setcategoryModal(true);
                                  setcategories(categories);
                                }}>View</Button>
                            ) : "--"}
                          </td>

                          <td style={{ textAlign: "center" }}>
                            <BSBadge bg={isfeatured ? "success" : "danger"}>
                              {isfeatured ? "Yes" : "No"}
                            </BSBadge>
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {comments == false ? (
                              <BSBadge bg="danger">No</BSBadge>
                            ) : (
                              <IconButton
                                type="acl"
                                role={450011}>
                                <Badge
                                  color="error"
                                  badgeContent={postcommentcount}
                                  showZero
                                >
                                  <ChatIcon
                                    style={{ color: "#1976d2", cursor: "pointer" }}
                                    onClick={() => navigate(`/blog-management/post-comments/${id}/${title}`)}
                                  />
                                </Badge>
                              </IconButton>
                            )}
                          </td>

                          <td>
                            <div className="d-flex justify-content-center">
                              {/* {roles.includes(130400) && ( // Role check for rendering the input */}
                              <DisplaySwitch
                                checked={displayorder == 1}
                                onChange={() => {
                                  setSelectId(id);
                                  handleUpdateTopDisplay(id);
                                }}
                                type="acl"
                                role={450009}
                              />

                              {/* <input
                                type="number"
                                min={1}
                                value={
                                  editedDisplayOrder[id] !== undefined
                                    ? editedDisplayOrder[id]
                                    : displayorder
                                }
                                onBlur={() => handleBlur(id, editedDisplayOrder[id])}
                                onChange={(e) => {
                                  setEditedDisplayOrder((prev) => ({
                                    ...prev,
                                    [id]: e.target.value,
                                  }));
                                }}
                                onKeyDown={(e) => {
                                  if (e.key === "Enter") {
                                    handleBlur(id, editedDisplayOrder[id]);
                                  }
                                }}
                                ref={inputRef}
                                style={{
                                  width: "73px",
                                  height: "31px",
                                  textAlign: "center",
                                  border: "1px solid #ccc",
                                  borderRadius: "5px",
                                  boxSizing: "border-box",
                                  outline: "none",
                                }}
                              /> */}


                              {/* )
                        } */}
                            </div>
                          </td>


                          <td style={{ textAlign: "center" }}>
                            <DisplaySwitch
                              checked={audioflag}
                              onChange={() => {
                                setSelectId(id);
                                setselectedAudioFlag(audioflag);
                                setselectedAudioFlagModal(true);
                              }}
                              type="acl"
                              role={450009}
                            />
                          </td>
                          <td style={{ textAlign: "center" }}>

                            {status}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            <Switch
                              checked={websitedisplay}
                              onChange={() => {
                                setSelectId(id);
                                setSelectedStatus(websitedisplay);
                                setdisplaywebsiteModal(true);
                              }}
                              type="acl"
                              role={450009}
                            />
                          </td>



                          <td style={{ textAlign: "center" }}>
                            <ReactionsTooltip like={postlikes} dislikes={postdislikes} views={postviews} />
                          </td>


                          <td style={{ maxWidth: "20px", whiteSpace: "normal", wordBreak: "break-word", minWidth: "0px" }}>
                            <div className="d-flex justify-content-center" style={{ alignItems: "center" }}>
                              {(status === "Draft" || usertypeid == 36 || usertypeid == 25) && (
                                <Link type="acl" role={450007} to={`update-post/${id}`}>
                                  <IconButton aria-label="edit" className="px-1 py-0">
                                    <EditIcon sx={{ color: "#4971B2" }} />
                                  </IconButton>
                                </Link>
                              )}
                              {status === "Approval Pending" && (
                                <IconButton type="acl" role={450008} aria-label="pending" className="px-1 py-0" onClick={() => {
                                  setSelectId(id);
                                  setapproveModal(true);
                                }}>
                                  <PendingActionsIcon sx={{ color: "#4971B2" }} /> {/* Use a suitable pending icon */}
                                </IconButton>
                              )}
                              {status === "Approved" && (
                                <IconButton aria-label="approved" className="px-1 py-0" disabled>
                                  <TaskAltIcon sx={{ color: "green" }} />
                                </IconButton>
                              )}
                              {(usertypeid == 36 || usertypeid == 25) && (
                                <IconButton
                                  aria-label="view"
                                  className="px-1 py-0"
                                  onClick={() => {
                                    setDeleteModal(true);
                                    setSelectId(id);
                                  }}
                                >
                                  <DeleteIcon sx={{ color: "#ff0000" }} />
                                </IconButton>
                              )}

                            </div>
                          </td>



                        </tr>
                      )
                    )
                  ) : (
                    <NotFound cols={9} />
                  )}
                </tbody>
              </Table>
            </div>
            {total >= 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={(e) => setActivePage(e)}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <ModalBox
        status={deleteModal}
        onClose={() => setDeleteModal(false)}
        title={"Delete Optional Subject"}
        size={"md"}
        description={"Are you sure want to delete this post"}
        customizedFooter={
          <Button onClick={handleDeletePost} {...submitButtonElement}>
            Delete
          </Button>
        }
      />

      <ModalBox
        custom={true}
        status={approveModal}
        onClose={() => setapproveModal(false)}
        size={"sm"}
        title={"Approve Post"}
        description={"Are you sure you want to approve the post?"}
        customizedFooter={
          <>
            <div>
              <Button onClick={handleApprovePost} {...submitButtonElement}>
                Yes
              </Button>
              <Button
                className="mx-2"
                onClick={() => {
                  setapproveModal(false);
                  setSelectId("");
                }}
              >
                No
              </Button>
            </div>
          </>
        }
      // custom={false}
      // Close={true}
      />

      {/* // ********************************* View Content Modal ************************************* */}
      <ModalBox
        status={viewModal}
        onClose={() => setViewModal(false)}
        // closeIcon
        size={"lg"}
        title={"View Content"}
        description={
          <>
            <div
              className="custom-content"
              style={{
                border: "0.1px solid #bbb",
                padding: "10px",
                textAlign: "left",
              }}
            >
              {parse(data.content1 || "")}
            </div>
            {/* <div className="row mt-1">
              <div className="col-12 col-sm-12 col-md-12 col-lg-11 col-xl-11 mx-auto">
                <div className="form-group row mt-1">
                  <div className="col-sm-12 col-form-label order-1 d-flex flex-column justify-content-end">
                    <div className="row">
                      <div className="col-sm-12 col-form-label">
                        <TextEditor
                          value={data.content}
                          name="content"
                          // onChange={(value) =>
                          //   setData({ ...data, content1: value })
                          // }
                          // label={"Content"}
                          // error={errorField.content}
                          // required
                          {...submitButtonElement}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div> */}
          </>
        }
        customizedFooter={true}
        custom={false}
        Close={true}
      />

      <ModalBox
        status={displaywebsiteModal}
        onClose={() => setdisplaywebsiteModal(false)}
        title={"Change Display Website Status"}
        description={"You want to change status for website display?"}
        customizedFooter={
          <Button onClick={updateDisplayWebsiteHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />
      <ModalBox
        status={selectedAudioFlagModal}
        onClose={() => setselectedAudioFlagModal(false)}
        title={"Change Audio Visible Status"}
        description={"You want to change status for audio visible?"}
        customizedFooter={
          <Button onClick={updateAudioVisibleHandler} {...submitButtonElement}>
            Yes
          </Button>
        }
      />

      <ModalBox
        status={shortdescriptionModal}
        onClose={() => setshortdescriptionModal(false)}
        // closeIcon
        size={"sm"}
        title={"View Short Description"}
        description={
          <>
            <div
              className="custom-content"
              style={{
                border: "0.1px solid #bbb",
                padding: "10px",
                textAlign: "left",
              }}
            >
              {Shortdescription}
            </div>
          </>
        }
        customizedFooter={true}
        custom={false}
        Close={true}
      />
      <ModalBox
        status={categoryModal}
        onClose={() => setcategoryModal(false)}
        // closeIcon
        size={"sm"}
        title={"View Categories"}
        description={
          <div
            className="custom-content"
            style={{
              border: "0.1px solid #bbb",
              padding: "10px",
              textAlign: "left",
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {categories && categories.length > 0 ? (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f2f2f2",
                        textAlign: "left",
                        fontWeight: "500"
                      }}
                    >
                      Parent Category
                    </th>
                    <th
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        backgroundColor: "#f2f2f2",
                        textAlign: "left",
                        fontWeight: "500"
                      }}
                    >
                      Sub Category
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {Object.entries(groupedCategories).map(([parentId, group]) => (
                    group.items.map((cat, idx) => (
                      <tr key={`${parentId}-${idx}`}>
                        {idx === 0 ? (
                          <td
                            rowSpan={group.items.length}
                            style={{ border: "1px solid #ddd", padding: "8px", verticalAlign: "top", color: "#343434" }}
                          >
                            {group.parentTitle}
                          </td>
                        ) : null}
                        <td style={{ border: "1px solid #ddd", padding: "8px", color: "#343434" }}>
                          {cat.categoryTitle}
                        </td>
                      </tr>
                    ))
                  ))}
                </tbody>
              </table>
            ) : (
              <p>No categories found.</p>
            )}
          </div>
        }

        customizedFooter={true}
        custom={false}
        Close={true}
      />
      <IframePreview
        url={selectedViewUrl}
        onClose={() => setSelectedViewUrl("")}
      />
    </>
  );
}
